import v2026 from '@/sui/data/sheets/edit/badicause/2026'

const result = {
  '2026': v2026.sheet
}

export default result
